<div class="loader-overlay" [style.backgroundColor]="overlayBackgroundColor">
  <div class="loader"></div>
</div>
